import { defineComponent as _defineComponent } from 'vue'
import { StreamingChartInfo } from '@/@types/graphql-types';

import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartsTrend',
  props: {
    streamingChartInfo: null
  },
  setup(__props: any) {

const props = __props as {
	streamingChartInfo: StreamingChartInfo | undefined;
};



return { __sfc: true,props, faChevronUp, faChevronDown }
}

})